<template>
    <div>
        <shop-head currentPageName="selection"></shop-head>
        <div class="container">
            <div class="image_box">
                <p class="title">广园汇汽配港 汽摩配选品中心让汽配出海更简单！</p>
                <img src="../../assets/images/selection_1.png" alt="">
                <img src="../../assets/images/selection_2.png" alt="">
                <img src="../../assets/images/selection_3.png" alt="">
                <img src="../../assets/images/selection_4.png" alt="">
                <img src="../../assets/images/selection_5.png" alt="">
                <img src="../../assets/images/selection_6.png" alt="">
            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
export default {
    components: {
        shopHead,
        commonFooter
    },
    data() {
        return {
            aboutInfo: [[], []]
        }

    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.image_box {
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .title {
        width: 636px;
        line-height: 68px;
        color: rgba(12, 64, 114, 1);
        font-size: 48px;
        text-align: center;
        font-weight: bold;
        font-family: YSBiaoTiHei-regular;
        margin: 0 auto;
    }
}
</style>